<template>
  <div>
    <emails-sent-report-table
      ref="table"
      :url="indexUrl"
      :filter-list="filters"
      :download-url="downloadUrl"
      :can-download="canDownload"
    ></emails-sent-report-table>
  </div>
</template>

<script>
import EmailsSentReportTable from '../../components/reports/emails-sent/table';
import eventBus from '../../event-bus';

export default {
  components: {
    EmailsSentReportTable,
  },

  props: {
    indexUrl: String,
    filters: Array,
    downloadUrl: String,
    canDownload: Boolean,
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.table.refresh();
    },
  },

  created() {
    eventBus.$on('refresh-emails-sent-report-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-emails-sent-report-table', this.refresh);
  }
}
</script>
